import type { FeedAction } from "./feedReducer";
import type { StreamOutcome } from "./streamRunner";

/** Коды отказа до потока, при которых план не выполнялся (п. 4 спеки). */
const REJECTED_STATUSES = new Set([400, 404, 409]);

/**
 * Что делать с лентой после «Сделать» (Task 18: 400 CONFIRMATION_REQUIRED,
 * 404 NOT_FOUND, 409 NOT_DRAFT, 403 DISABLED, 401/415/5xx прочие).
 * refetch: подтянуть с сервера настоящий статус плана.
 */
export function planOutcome(
  planId: string,
  res: StreamOutcome
): { action: FeedAction | null; refetch: boolean } {
  if (res.aborted) return { action: null, refetch: false };
  if (res.error) {
    if (REJECTED_STATUSES.has(res.status)) {
      return { action: { type: "planRejected", planId }, refetch: true };
    }
    if (res.status === 403 && res.error === "DISABLED") {
      return {
        action: { type: "planFailed", planId, blocked: "DISABLED" },
        refetch: false,
      };
    }
    return {
      action: { type: "planFailed", planId, blocked: null },
      refetch: false,
    };
  }
  if (!res.planStatuses.has(planId)) {
    // Поток оборван до итога плана: шаги могли выполниться частично.
    return {
      action: { type: "planFailed", planId, blocked: null },
      refetch: true,
    };
  }
  if (!res.finished) {
    return { action: { type: "failed" }, refetch: false };
  }
  return { action: null, refetch: false };
}
